<template>
  <div class="slider-two">
    <div class="shane_tm_hero" id="home" data-style="three">
      <div class="header_banner">Spices &#183; Caviar &#183; Mushrooms &#183; Nuts & Seeds &#183; Fruit &#183; More!</div>
      <div class="header_title_container">
        <h1 class="header_title">
          Explore Spices and Specialty Foods<br>
        </h1>
        <div class="header_line">
        </div>
        <p class="header_p">
          We sell to chefs in Northeast Florida, six days a week. Get in touch to order from a constantly expanding catalog, including seasonal items!
        </p>
      </div>
      <div class="background_giant"></div>
      <!-- <div class="background">
        <div
          class="image"
        ></div>
      </div> -->
      <!-- End .background -->

      <div class="container">
        <div class="content">
          <!-- <div class="name_wrap">
            <h3>Saturiwa<span><br/>Trading<br/>Company</span></h3>
          </div> -->
           <!--<span class="overlay_effect"></span> this goes before </h3>-->
          <!-- End title -->

          <!-- <div class="job_wrap">
            <span class="job">
              Exotic Foods
              <span class="overlay_effect"></span>
            </span>
          </div> -->
          <!-- End designation -->
          <!-- <Social /> -->
        </div>
        <!-- End content -->

        <div class="shane_tm_down loaded">
          <div class="line_wrapper">
            <div class="line"></div>
          </div>
        </div>
      </div>
      <!-- End .container -->
    </div>
  </div>
</template>

<script>
// import Social from "../SocialTwo.vue";
export default {
  components: {
    // Social,
  },
  data() {
    return {
      // sliderHero: require("~@/assets/img/logo/logo.png"),
    };
  },
};
</script>

<style lang="scss" scoped></style>

<style lang="css" scoped>
  
  .image {
    background: url("~@/assets/img/logo/logo.png");
    background-size: contain;
    background-repeat:  no-repeat;
    top: 100px;
    right: 30px;
  }
  .shane_tm_hero .content h3 span {
    -webkit-text-stroke-width: 1.7px;
    /* -webkit-text-stroke: 1.7px #000 !important; */
  }
</style>
